// extracted by mini-css-extract-plugin
export var bodyContainer = "EmployeeCard-module--bodyContainer--f2CYk";
export var card = "EmployeeCard-module--card--Pl0Hf";
export var ctas = "#226355";
export var description = "EmployeeCard-module--description--CRCqR";
export var grayBackground = "#f6f8fb";
export var imageContainer = "EmployeeCard-module--imageContainer--Zj6R0";
export var title = "EmployeeCard-module--title--RQjz+";